export default {
  "container": "_container_1gn446",
  "title": "_title_1gn446"
};
